import React from "react";

const ApplyForm = () => {
  return (
    <section className="container mt-5">
      <div className="row my-4">
        <iframe
          title="form"
          width="100%"
          height="1850px"
          src="https://forms.office.com/Pages/ResponsePage.aspx?id=KYJsGaVSEkCuAuXGKlet7z1hY1rB2FtLvH1Xwu7VLa9UNkRBWEVCWjFUU0tWQUxaQUdVMFdXM0MzNS4u"
          frameBorder="0"
          marginWidth="0"
          marginHeight="0"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default ApplyForm;
